import { useMemo } from 'react';
import { useTasksQuery } from '../../api/queries/tasks';
import { useNavigate } from 'react-router';
import { Modal } from '@convergence/components';
import { TaskGroupDetail } from './TaskGroupDetail';
import { useStateUrlSimple } from '../../hooks/useStateUrlSimple';

export interface TasksProps {
  slug: string;
}

export function Tasks(props: TasksProps) {
  const tasksQuery = useTasksQuery(props.slug);
  const [taskGroup, setTaskGroup] = useStateUrlSimple('taskGroup', '');

  const tasksGroupedByName = useMemo(() => {
    const output: Record<string, typeof tasksQuery.data> = {};
    if (tasksQuery.data) {
      for (const task of tasksQuery.data.tasks) {
        if (!output[task.name]) {
          output[task.name] = [];
        }
        output[task.name].push(task);
      }
    }
    return output;
  }, [tasksQuery.data]);

  return (
    <div className="flex flex-col p-4">
      {tasksQuery.isLoading && <TasksSkeleton />}
      {Object.entries(tasksGroupedByName).map(([name, tasks]) => (
        <TaskGroup key={name} name={name} tasks={tasks} />
      ))}
      {Object.keys(tasksGroupedByName).length > 0 && (
        <Modal
          variant="fit"
          containerClassName="overflow-hidden h-[75vh] w-[75vw]"
          visible={!!taskGroup}
          onClose={() => {
            setTaskGroup('');
          }}
        >
          <div className="p-4 w-full h-full overflow-scroll bg">
            {taskGroup && (
              <TaskGroupDetail
                name={taskGroup}
                analysisSlug={''}
                tasks={tasksGroupedByName[taskGroup]}
              />
            )}
          </div>
        </Modal>
      )}
    </div>
  );
}

export interface TaskGroupProps {
  name: string;
  tasks: Array<{
    id: string;
    name: string;
    status: string;
    startedAt: string | null;
    completedAt: string | null;
    logUrl: string | null;
  }>;
}

export function TaskGroup(props: TaskGroupProps) {
  const [, setTaskGroup] = useStateUrlSimple('taskGroup', '');
  return (
    <button
      onClick={() => {
        setTaskGroup(props.name);
      }}
      className="bg-white border-black border-b p-4 text-left hover:bg-gray-200"
    >
      {props.name} ({props.tasks.length})
    </button>
  );
}

function TasksSkeleton() {
  const fakeTaskGroups = Array.from({ length: 8 }).map((_, index) => index);
  return (
    <div className="flex flex-col gap-4 w-full">
      {fakeTaskGroups.map((index) => (
        <div
          key={index}
          className="bg-white border-black border-b p-4 text-left hover:bg-gray-200 sweep flex gap-4"
        >
          <div className="w-28 h-4 bg-gray-200 pulse"></div>
          <div className="w-4 h-4 bg-gray-200 pulse"></div>
        </div>
      ))}
    </div>
  );
}
